const transformFileWithPhotoInformation = file => ({
  path: file.data.relativePath,
  width: file.file.width,
  height: file.file.height,
  reporter: file.file.reporter || '',
  source: file.file.source || '',
  text: file.file.content || '',
});

export default transformFileWithPhotoInformation;
